import { useContext } from 'react';
import {
  ResponseTemplateStateContext,
  ResponseTemplateSetStateContext,
} from './provider';

export const useResponseTemplateState = () => {
  const context = useContext(ResponseTemplateStateContext);
  if (context === undefined) {
    throw new Error(
      'useResponseTemplateState должен использоваться внутри ResponseTemplateModalProvider'
    );
  }
  return context;
};

export const useResponseTemplateSetState = () => {
  const context = useContext(ResponseTemplateSetStateContext);
  if (context === undefined) {
    throw new Error(
      'useResponseTemplateSetState должен использоваться внутри ResponseTemplateModalProvider'
    );
  }
  return context;
};
